import styled from 'styled-components';

export const BusinessSearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
    overflow-y: scroll;
`;

export const ResultsHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: #666;
`;

export const LoadingContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-top: 1rem;
`;
